import DictionaryTrigger from './DictionaryTrigger';
export * from './DictionaryTrigger';
export default DictionaryTrigger;
